import { Checkbox } from 'antd';

const CheckboxShare = ({ options = [], disabled = false, onChange,value }) => {
  const handleChange = (checkedValues) => {
    onChange(checkedValues); 
  };

  return (
    <Checkbox.Group
      value={value}
      options={options.map((opt) => ({ label: opt.label || opt, value: opt.value || opt }))}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

export default CheckboxShare;